import { render, staticRenderFns } from "./AbkActualRecrutationsBox.vue?vue&type=template&id=4930679b&scoped=true&"
import script from "./AbkActualRecrutationsBox.vue?vue&type=script&lang=js&"
export * from "./AbkActualRecrutationsBox.vue?vue&type=script&lang=js&"
import style0 from "./AbkActualRecrutationsBox.vue?vue&type=style&index=0&id=4930679b&lang=scss&scoped=true&"
import style1 from "./AbkActualRecrutationsBox.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4930679b",
  null
  
)

export default component.exports